import React, { useEffect, useState, useCallback } from 'react'
import { get } from '../../ApiServices/ApiServices';
function MostRental() {
    const [totalItems, setTotalItems] = useState(40);
    const [inventoryRatings, setInventoryRatings] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const fetchInventoryRatings = async (page, limit) => {
        try {
            const response = await get(`inventories-ratings?page_number=${page}&size=${limit}`);
            if (response?.status && response?.data?.rows) {
                setInventoryRatings(response?.data?.rows);
                setTotalItems(response?.data?.count)
            }
        } catch (error) {
            console.error('Error fetching inventory ratings:', error);
        }
    };

    useEffect(() => {
        fetchInventoryRatings(1, 10);

    }, []);

    useEffect(() => {
        fetchInventoryRatings(currentPage, itemsPerPage);
    }, [currentPage, itemsPerPage]);

    const handlePageChange = (page) => setCurrentPage(page);
    const handleItemsPerPageChange = (e) => {
        const newLimit = parseInt(e.target.value);
        setItemsPerPage(newLimit);
        setCurrentPage(1);
    };


    const totalPages = Math.ceil(totalItems / itemsPerPage);
    return (
        <>
            <div className="row align-items-center justify-content-between">
                <div className="col-md-6">
                    <h5>Most Rented Styles Report</h5>
                </div>
            </div>

            <div className="row mt-3">
                <div className="col-md-12">

                    <div
                        className="table-responsive"
                        style={{
                            overflow: "visible",
                            minHeight: "auto"
                        }}
                    >
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Style Name</th>
                                    <th scope="col">Category</th>
                                    <th scope="col" style={{ textAlign: "center" }}>Times Rented (YTD)</th>
                                    <th scope="col" style={{ textAlign: "center" }}>Popularity Heat</th>
                                </tr>
                            </thead>

                            <tbody>
                                {inventoryRatings && inventoryRatings.length > 0 ? (
                                    inventoryRatings.map((item, index) => {
                                        const ratingNumber = parseInt(
                                            item.rating?.replace("inventory_rating_", "") || "0"
                                        );

                                        const getFireClass = () => {
                                            if (ratingNumber >= 5) return "brightred";
                                            if (ratingNumber >= 3) return "ornageHot";
                                            return "yellowHot";
                                        };

                                        return (
                                            <tr key={item.id || index}>
                                                <th scope="row">
                                                    {item.style || "N/A"} {item.description || "N/A"}
                                                </th>

                                                <td>{item.category?.name || "N/A"}</td>

                                                <td style={{ textAlign: "center" }}>{item.count || "0"}</td>

                                                <td className="fireIconGap">
                                                    {ratingNumber > 0 ? (
                                                        [...Array(ratingNumber)].map((_, i) => (
                                                            <span key={i} className={getFireClass()}>
                                                                <i className="fa-solid fa-fire"></i>
                                                            </span>
                                                        ))
                                                    ) : (
                                                        <span className="text-muted">No rating</span>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center text-muted py-4">
                                            Most Rented Style Report not available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {inventoryRatings.length > 0 && (
                            <div
                                className="nk-block-between-md g-2"
                                style={{
                                    marginTop: "5px",
                                    paddingTop: "0px"
                                }}
                            >
                                <div className="g">
                                    <div className="pagination d-flex gap-2">
                                        <button
                                            className={`btn btn-sm ${currentPage === 1 ? "btn-disabled" : "btn-primary"
                                                }`}
                                            style={{ height: "35px" }}
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </button>

                                        {Array.from({ length: totalPages }, (_, i) => (
                                            <button
                                                key={i + 1}
                                                className={`btn btn-sm ${currentPage === i + 1
                                                    ? "btn-primary"
                                                    : "btn-outline-primary"
                                                    }`}
                                                style={{ height: "35px" }}
                                                onClick={() => handlePageChange(i + 1)}
                                            >
                                                {i + 1}
                                            </button>
                                        )).slice(
                                            Math.max(0, currentPage - 3),
                                            Math.min(currentPage + 2, totalPages)
                                        )}

                                        <button
                                            className={`btn btn-sm ${currentPage === totalPages
                                                ? "btn-disabled"
                                                : "btn-primary"
                                                }`}
                                            style={{ height: "35px" }}
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>
                                    </div>
                                </div>

                                {inventoryRatings.length >= 10 && (
                                    <div className="g">
                                        <div className="pagination-goto d-flex justify-content-center justify-content-md-start gx-3">
                                            <div>Showing</div>

                                            <div>
                                                <select
                                                    className="form-select js-select2"
                                                    value={itemsPerPage}
                                                    onChange={handleItemsPerPageChange}
                                                >
                                                    {totalItems >= 10 && <option value="10">10</option>}
                                                    {totalItems >= 20 && <option value="20">20</option>}
                                                    {totalItems >= 50 && <option value="50">50</option>}
                                                    {totalItems >= 100 && <option value="100">100</option>}
                                                </select>
                                            </div>

                                            <div>of {totalItems} items</div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                </div>

            </div>
        </>
    )
}

export default MostRental
